import Vue from 'vue';

import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.MIX_GOOGLE_MAPS_KEY,
        language: process.env.MIX_GOOGLE_MAPS_LANGUAGE,
        libraries: "geocoder, directions, places"
    }
});
